import { useState, useEffect } from 'react';
import { Card } from './ui/card';
import { Badge } from './ui/badge';
import { Button } from './ui/button';
import { ImageWithFallback } from './figma/ImageWithFallback';
import { FloatingParticles } from './ParticleAnimation';
import { 
  Linkedin, 
  Twitter, 
  Github, 
  Mail, 
  Award, 
  Users, 
  Code, 
  Lightbulb,
  ChevronLeft,
  ChevronRight,
  Crown,
  Star,
  Youtube,
  Palette
} from 'lucide-react';

export function TeamSection() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [slideDirection, setSlideDirection] = useState<'next' | 'prev'>('next');

  // Separate leadership and team members
  const leadership = [
    {
      name: 'Christopher Indra Sinarya',
      role: 'CEO & Co-Founder',
      department: 'Leadership',
      bio: 'Visionary leader with 15+ years in tech innovation and strategic planning. Former VP at major tech companies, leading digital transformation initiatives.',
      image: '/assets/teams/CTP.jpg',
      expertise: ['Strategic Planning', 'AI Innovation', 'Team Building', 'Investment', 'Digital Transformation'],
      social: {
        linkedin: '#',
        twitter: '#',
        email: '#'
      },
      color: 'primary',
      achievements: ['Forbes 30 Under 30', 'AI Innovation Award 2023', '3x Successful Exits']
    }
  ];

  const teamMembers = [
    // First slide: Single card for Megah Haristuni
    [
      {
        name: 'Megah Haristuni',
        role: 'CFO',
        department: 'Finance',
        bio: '“Always learning, always growing — because work is more than just results, it’s a journey.”',
        image: '/assets/teams/megah.png',
        expertise: ['Financial Planning', 'Budgeting', 'Risk Management', 'Investment Analysis'],
        social: {
        },
        color: 'secondary'
      }
    ],
    // Second slide: Single card for Anif Burhannudin
    [
      {
        name: 'Anif Burhannudin',
        role: 'Technician IT',
        department: 'Technician IT',
        bio: '“Coba matiin dulu 3-5 menit..!!!”',
        image: '/assets/teams/anif.png',
        expertise: ['Yapping', 'Soundboard', 'Stand Up Comedy', 'Informant'],
        social: {
          linkedin: 'https://www.linkedin.com/in/anif-burhanudin-a98319214/',
          email: 'jamananip@gmail.com'
        },
        color: 'secondary'
      }
    ],
    // Third slide: Single card for Shalih Rizaldy
    [
      {
        name: 'Shalih Rizaldy',
        role: 'Senior Full Stack Developer',
        department: 'Development',
        bio: '“Nobody is perfect, I\'m nobody, so I\'m perfect.”',
        image: '/assets/teams/shalih.png',
        expertise: ['Project Management', 'Client Relations', 'Game Development', 'Unity'],
        social: {
          linkedin: 'https://www.linkedin.com/in/shalihrizal/',
          behance: 'https://www.behance.net/shalihrizal'
        },
        color: 'accent'
      }
    ],
    // Fourth slide: Single card for Dimas Aji Permadi
    [
      {
        name: 'Dimas Aji Permadi',
        role: 'Senior Full Stack Developer',
        department: 'Systems Analyst',
        bio: 'Full-stack developer with expertise in modern web technologies and cloud platforms.',
        image: '/assets/teams/dimas.png',
        expertise: ['Project Management', 'Laravel', 'Analyst', 'Documentation'],
        social: {
          linkedin: '#',
          github: '#',
          email: 'dimas@diroi.com'
        },
        color: 'accent'
      }
    ],

    // Fifth slide: Single card for Raden Hikmat Ramadhan
    [
      {
        name: 'Raden Hikmat Ramadhan',
        role: 'Senior Full Stack Developer',
        department: 'IoT Engineer',
        bio: '“God Removes People From Your Life Because God Heard Conversation You Didnt”',
        image: '/assets/teams/tian.png',
        expertise: ['Photoshop', 'Adobe Premiere', 'AWS', 'GraphQL'],
        social: {
          linkedin: 'https://www.linkedin.com/in/radenhikmatramadhan/',
          youtube: 'https://youtube.com/@mrraden0442?si=ycYSBRFEtR9oh0Bu'
        },
        color: 'secondary'
      }
    ],

    // Sixth slide: Three cards for other team members (if needed in the future)
    [
              {
          name: 'Azie Abdul Aziz Nurfauzi',
          role: 'Senior Full Stack Developer',
          department: 'Development',
          bio: '“Real is rare , fake is everywhere.”',
          image: '/assets/teams/azie.png',
          expertise: ['Laravel', 'UI/UX', 'Figma', 'Tailwind CSS', 'Javascript', 'Html', 'CSS'],
          social: {
            linkedin: 'https://www.linkedin.com/in/azieabdul14/',
            github: 'https://github.com/Azieabdul',
            email: 'azieabdul14@gmail.com'
          },
          color: 'accent'
        },
            {
            name: 'Sylvania Diva Jezreelia',
            role: 'Senior Full Stack Developer',
            department: 'Development',
            bio: '“Think. Solve. Deploy.”',
            image: '/assets/teams/dj.png',
            expertise: ['PHP', 'Laravel', 'API Development', 'Performance Optimization', 'Machine Learning'],
            social: {
              linkedin: 'https://www.linkedin.com/in/jezreeldiva/',
              github: 'https://github.com/Jezreeldv',
              email: '#'
            },
          color: 'primary'
      },
              {
          name: 'Muhammad Agyar Aly Fikri',
          role: 'Senior Full Stack Developer',
          department: 'Development',
          bio: '“Hidup itu sederhana, yang rumit itu cara kita memikirkannya.”',
          image: '/assets/teams/agyar.png',
          expertise: ['JavaScript', 'Laravel', 'Mysql', 'React', 'UI/UX', 'Vue', 'Html', 'Css', 'Python', 'Flutter', 'Unity', 'Unreal Engine'],
          social: {
          },
          color: 'secondary'
        }
    ],
      // Seventh slide)
      [
        {
      name: 'Muhammad Ziyan Ghasani',
      role: 'Senior Full Stack Developer',
      department: 'Development',
      bio: '“Silence will not solve problems, but silence will not cause problems either.”',
      image: '/assets/teams/zian.png',
      expertise: ['Laravel', 'Html', 'Javascript'],
      social: {
      linkedin: '#',
      github: '#',
      twitter: '#',
      email: 'ziyan@diroi.com'
      },
      color: 'accent'
      },
      {
      name: 'Selpa Rizqi',
      role: 'Senior Full Stack Developer',
      department: 'Development',
      bio: '“You have three currencies: knowledge, time, and money. When you need one, use the other two to get it.”',
      image: '/assets/teams/selva.png',
      expertise: ['Laravel', 'PHP', 'CSS', 'Html','Flutter', 'YII', 'API', 'Postgresql'],
      social: {
        linkedin: '#',
        github: '#',
        email: 'selpa@diroi.com'
      },
      color: 'primary'
      },
      {
        name: 'Tata',
        role: 'Driver',
        department: 'Driver',
        bio: '“Driver for ever...!!”',
        image: '/assets/teams/tata.png',
        expertise: ['Driver', 'Car', 'Motorcycle', 'Bus', 'Truck'],
        social: {
          
        },
        color: 'accent'
        },
        
      ]
  ];

  const departments = [
    { name: 'Leadership', icon: Award, count: 1, color: 'primary' },
    { name: 'Engineering', icon: Code, count: 8, color: 'secondary' },
    { name: 'Design', icon: Lightbulb, count: 2, color: 'accent' },
    { name: 'Technician IT', icon: Users, count: 1, color: 'primary' }
  ];

  const totalSlides = 1 + teamMembers.length;

  const nextSlide = () => {
    if (isAnimating) return;
    setSlideDirection('next');
    setIsAnimating(true);
    setCurrentSlide((prev) => (prev + 1) % totalSlides);
    setTimeout(() => setIsAnimating(false), 800);
  };

  const prevSlide = () => {
    if (isAnimating) return;
    setSlideDirection('prev');
    setIsAnimating(true);
    setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides);
    setTimeout(() => setIsAnimating(false), 800);
  };

  const goToSlide = (index: number) => {
    if (isAnimating || index === currentSlide) return;
    setSlideDirection(index > currentSlide ? 'next' : 'prev');
    setIsAnimating(true);
    setCurrentSlide(index);
    setTimeout(() => setIsAnimating(false), 800);
  };

  // Auto-advance slides
  useEffect(() => {
    const interval = setInterval(() => {
      if (!isAnimating) {
        nextSlide();
      }
    }, 6000);

    return () => clearInterval(interval);
  }, [isAnimating]);

  const renderLeadershipCard = (member: typeof leadership[0]) => (
    <div className="flex justify-center">
      <Card className={`w-full max-w-2xl group overflow-hidden bg-card/30 backdrop-blur border-${member.color}/20 hover:border-${member.color}/40 transition-all duration-300 hover:tech-glow hover:-translate-y-2 relative opacity-0 ${currentSlide === 0 ? 'animate-back-in-right' : ''}`}>
        {/* Enhanced Leadership Badge */}
        <div className="absolute top-4 right-4 z-20">
          <Badge className="bg-primary/20 text-primary border-primary/30 font-orbitron">
            <Crown className="w-3 h-3 mr-1" />
            Leadership
          </Badge>
        </div>

        {/* Particle overlay */}
        <div className="absolute inset-0 opacity-20 pointer-events-none">
          <FloatingParticles 
            density={12}
            size="small"
            colors={['#FFD700', '#00FFFF']}
          />
        </div>

        <div className="relative">
          {member.image ? (
            <div className="relative h-80 overflow-hidden">
              <ImageWithFallback
                src={member.image}
                alt={member.name}
                className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-card/90 to-transparent"></div>
            </div>
          ) : (
            <div className={`h-80 bg-gradient-to-br from-${member.color}/20 to-${member.color}/5 flex items-center justify-center`}>
              <div className={`w-32 h-32 bg-${member.color}/20 rounded-full flex items-center justify-center tech-glow`}>
                <span className={`text-4xl font-orbitron font-bold text-${member.color}`}>
                  {member.name.split(' ').map(n => n[0]).join('')}
                </span>
              </div>
            </div>
          )}
        </div>
        
        <div className="p-8 relative z-10">
          <div className="text-center mb-6">
            <h3 className={`text-3xl font-orbitron font-bold text-${member.color} mb-2`}>
              {member.name}
            </h3>
            <p className="text-xl text-muted-foreground font-medium mb-4">
              {member.role}
            </p>
            <p className="text-muted-foreground leading-relaxed max-w-xl mx-auto">
              {member.bio}
            </p>
          </div>

          {/* Achievements */}
          {member.achievements && (
            <div className="mb-6">
              <div className="text-sm text-muted-foreground font-medium mb-3 flex items-center justify-center">
                <Star className="w-4 h-4 mr-2" />
                ACHIEVEMENTS
              </div>
              <div className="flex flex-wrap justify-center gap-2">
                {member.achievements.map((achievement, index) => (
                  <Badge 
                    key={index} 
                    variant="outline" 
                    className={`text-xs border-${member.color}/30 text-${member.color} bg-${member.color}/5`}
                  >
                    {achievement}
                  </Badge>
                ))}
              </div>
            </div>
          )}
          
          <div className="mb-6">
            <div className="text-sm text-muted-foreground font-medium mb-3 text-center">EXPERTISE</div>
            <div className="flex flex-wrap justify-center gap-2">
              {member.expertise.map((skill, skillIndex) => (
                <Badge 
                  key={skillIndex} 
                  variant="outline" 
                  className={`text-sm border-${member.color}/30 text-${member.color}`}
                >
                  {skill}
                </Badge>
              ))}
            </div>
          </div>
          
          <div className="flex justify-center space-x-3">
            {member.social.linkedin && (
              <Button 
                variant="ghost" 
                size="sm" 
                className={`p-3 hover:bg-${member.color}/10 hover:text-${member.color} transition-all duration-300`}
                onClick={() => window.open(member.social.linkedin, '_blank')}
              >
                <Linkedin className="w-5 h-5" />
              </Button>
            )}
            {member.social.twitter && (
              <Button 
                variant="ghost" 
                size="sm" 
                className={`p-3 hover:bg-${member.color}/10 hover:text-${member.color} transition-all duration-300`}
                onClick={() => window.open(member.social.twitter, '_blank')}
              >
                <Twitter className="w-5 h-5" />
              </Button>
            )}
            {member.social.email && (
              <Button 
                variant="ghost" 
                size="sm" 
                className={`p-3 hover:bg-${member.color}/10 hover:text-${member.color} transition-all duration-300`}
                onClick={() => window.open(`mailto:${member.social.email}`, '_blank')}
              >
                <Mail className="w-5 h-5" />
              </Button>
            )}
          </div>
        </div>
      </Card>
    </div>
  );

  const renderTeamCard = (member: typeof teamMembers[0][0], index: number, slideIndex: number) => {
    const isCurrentSlide = currentSlide === slideIndex + 1;
    const animationDelay = index * 300; // Stagger animation by 100ms per card
    const isSingleCard = slideIndex <= 4; // Check if this is a single card slide
    
    return (
      <Card 
        key={member.name}
        className={`group overflow-hidden bg-card/30 backdrop-blur border-${member.color}/20 hover:border-${member.color}/40 transition-all duration-300 hover:tech-glow hover:-translate-y-2 h-full relative opacity-0 ${isCurrentSlide ? 'animate-back-in-right' : ''} ${isSingleCard ? 'max-w-2xl mx-auto' : ''}`}
        style={{ animationDelay: `${animationDelay}ms` }}
      >
                {/* Special floating particles for single card slides */}
        {isSingleCard && (
          <div className="absolute inset-0 opacity-20 pointer-events-none">
            <FloatingParticles 
              density={8}
              size="small"
              colors={['#FFD700', '#00FFFF']}
            />
          </div>
        )}
        
        {/* Special badge for single card slides */}
        {isSingleCard && (
          <div className="absolute top-4 right-4 z-20">
            <Badge className={`bg-${member.color}/20 text-${member.color} border-${member.color}/30 font-orbitron`}>
              <Star className="w-3 h-3 mr-1" />
              {member.department} Lead
            </Badge>
          </div>
        )}
        
        <div className="relative">
          {member.image ? (
            <div className={`relative overflow-hidden ${isSingleCard ? 'h-80' : 'h-64'}`}>
              <ImageWithFallback
                src={member.image}
                alt={member.name}
                className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500 bg-gradient-to-br from-card/10 to-card/5"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-card/60 to-transparent pointer-events-none"></div>
            </div>
          ) : (
            <div className={`bg-gradient-to-br from-${member.color}/20 to-${member.color}/5 flex items-center justify-center ${isSingleCard ? 'h-80' : 'h-64'}`}>
              <div className={`rounded-full flex items-center justify-center ${isSingleCard ? 'w-32 h-32' : 'w-24 h-24'} bg-${member.color}/20`}>
                <span className={`font-orbitron font-bold text-${member.color} ${isSingleCard ? 'text-4xl' : 'text-2xl'}`}>
                  {member.name.split(' ').map(n => n[0]).join('')}
                </span>
              </div>
            </div>
          )}
        </div>
        
        <div className={`${isSingleCard ? 'p-8' : 'p-6'}`}>
          <div className="mb-4">
            <Badge className={`mb-2 bg-${member.color}/20 text-${member.color} border-${member.color}/30 ${isSingleCard ? 'text-sm' : 'text-xs'}`}>
              {member.department}
            </Badge>
            <h3 className={`font-orbitron font-semibold text-${member.color} mb-1 ${isSingleCard ? 'text-3xl' : 'text-xl'}`}>
              {member.name}
            </h3>
            <p className={`text-muted-foreground font-medium ${isSingleCard ? 'text-xl' : 'text-base'}`}>
              {member.role}
            </p>
          </div>
          
          <p className={`text-muted-foreground mb-4 leading-relaxed ${isSingleCard ? 'text-lg' : 'text-sm'}`}>
            {member.bio}
          </p>
          
          <div className="space-y-2 mb-6">
            <div className={`text-muted-foreground font-medium ${isSingleCard ? 'text-sm' : 'text-xs'}`}>EXPERTISE:</div>
            <div className="flex flex-wrap gap-1">
              {member.expertise.map((skill, skillIndex) => (
                <Badge 
                  key={skillIndex} 
                  variant="outline" 
                  className={`border-${member.color}/30 text-${member.color} ${isSingleCard ? 'text-sm' : 'text-xs'}`}
                >
                  {skill}
                </Badge>
              ))}
            </div>
          </div>
          
          <div className="flex space-x-2">
            {(member.social as any).linkedin && (
              <Button 
                variant="ghost" 
                size="sm" 
                className={`hover:bg-${member.color}/10 hover:text-${member.color} ${isSingleCard ? 'p-3' : 'p-2'}`}
                onClick={() => window.open((member.social as any).linkedin, '_blank')}
              >
                <Linkedin className={`${isSingleCard ? 'w-5 h-5' : 'w-4 h-4'}`} />
              </Button>
            )}
            {(member.social as any).twitter && (
              <Button 
                variant="ghost" 
                size="sm" 
                className={`hover:bg-${member.color}/10 hover:text-${member.color} ${isSingleCard ? 'p-3' : 'p-2'}`}
                onClick={() => window.open((member.social as any).twitter, '_blank')}
              >
                <Twitter className={`${isSingleCard ? 'w-5 h-5' : 'w-4 h-4'}`} />
              </Button>
            )}
            {(member.social as any).github && (
              <Button 
                variant="ghost" 
                size="sm" 
                className={`hover:bg-${member.color}/10 hover:text-${member.color} ${isSingleCard ? 'p-3' : 'p-2'}`}
                onClick={() => window.open((member.social as any).github, '_blank')}
              >
                <Github className={`${isSingleCard ? 'w-5 h-5' : 'w-4 h-4'}`} />
              </Button>
            )}
            {(member.social as any).youtube && (
              <Button 
                variant="ghost" 
                size="sm" 
                className={`hover:bg-${member.color}/10 hover:text-${member.color} ${isSingleCard ? 'p-3' : 'p-2'}`}
                onClick={() => window.open((member.social as any).youtube, '_blank')}
              >
                <Youtube className={`${isSingleCard ? 'w-5 h-5' : 'w-4 h-4'}`} />
              </Button>
            )}
            {(member.social as any).behance && (
              <Button 
                variant="ghost" 
                size="sm" 
                className={`hover:bg-${member.color}/10 hover:text-${member.color} ${isSingleCard ? 'p-3' : 'p-2'}`}
                onClick={() => window.open((member.social as any).behance, '_blank')}
              >
                <Palette className={`${isSingleCard ? 'w-5 h-5' : 'w-4 h-4'}`} />
              </Button>
            )}
            {(member.social as any).email && (
              <Button 
                variant="ghost" 
                size="sm" 
                className={`hover:bg-${member.color}/10 hover:text-${member.color} ${isSingleCard ? 'p-3' : 'p-2'}`}
                onClick={() => window.open(`mailto:${(member.social as any).email}`, '_blank')}
              >
                <Mail className={`${isSingleCard ? 'w-5 h-5' : 'w-4 h-4'}`} />
              </Button>
            )}
          </div>
        </div>
      </Card>
    );
  };

  return (
    <section id="team" className="py-20 relative overflow-hidden">
      <div className="absolute inset-0 circuit-pattern opacity-10"></div>
      
      {/* Floating Particles */}
      <FloatingParticles 
        density={20}
        size="medium"
        colors={['#FFD700', '#00FFFF', '#00AEEF']}
        className="opacity-25"
      />
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <Badge className="mb-4 bg-accent/20 text-accent border-accent/30 font-orbitron">
            Our Team
          </Badge>
          <h2 className="text-4xl md:text-5xl font-orbitron font-bold text-primary mb-6">
            The Minds Behind Innovation
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-accent to-primary mx-auto mb-8"></div>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Meet the exceptional individuals who bring passion, expertise, and innovation 
            to every project we tackle.
          </p>
        </div>
        
        {/* Team Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">
          {departments.map((dept, index) => {
            const Icon = dept.icon;
            return (
              <Card key={index} className={`p-6 text-center bg-card/30 backdrop-blur border-${dept.color}/20 hover:border-${dept.color}/40 transition-all duration-300 hover:tech-glow`}>
                <Icon className={`w-8 h-8 text-${dept.color} mx-auto mb-4`} />
                <div className={`text-2xl font-orbitron font-bold text-${dept.color} mb-2`}>
                  {dept.count}
                </div>
                <div className="text-sm text-muted-foreground">
                  {dept.name}
                </div>
              </Card>
            );
          })}
        </div>
        
        {/* Team Slider */}
        <div className="relative mb-16">
          {/* Current Slide Content */}
          <div className="min-h-[600px] flex items-center justify-center">
            {/* Leadership Slide */}
            {currentSlide === 0 && (
              <div className="w-full px-4">
                {renderLeadershipCard(leadership[0])}
              </div>
            )}
            
            {/* Team Member Slides */}
            {teamMembers.map((slideMembers, slideIndex) => (
              currentSlide === slideIndex + 1 && (
                <div key={slideIndex + 1} className="w-full px-4">
                  {slideIndex <= 4 ? (
                    // First 5 slides: Single cards 
                    <div className="flex justify-center">
                      <div className="w-full max-w-2xl">
                        {renderTeamCard(slideMembers[0], 0, slideIndex)}
                      </div>
                    </div>
                  ) : (
                    // Last slide: Grid layout for multiple cards
                    <div className="grid md:grid-cols-3 gap-8">
                      {slideMembers.map((member, memberIndex) => 
                        renderTeamCard(member, memberIndex, slideIndex)
                      )}
                    </div>
                  )}
                </div>
              )
            ))}
          </div>
          
          {/* Navigation Buttons */}
          <div className="absolute top-1/2 -translate-y-1/2 left-0 right-0 flex justify-between pointer-events-none">
            <Button
              variant="ghost"
              size="sm"
              onClick={prevSlide}
              disabled={isAnimating}
              className="pointer-events-auto bg-card/50 backdrop-blur border border-primary/20 hover:border-primary/40 hover:bg-primary/10 tech-glow transition-all duration-300"
            >
              <ChevronLeft className="w-5 h-5 text-primary" />
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={nextSlide}
              disabled={isAnimating}
              className="pointer-events-auto bg-card/50 backdrop-blur border border-primary/20 hover:border-primary/40 hover:bg-primary/10 tech-glow transition-all duration-300"
            >
              <ChevronRight className="w-5 h-5 text-primary" />
            </Button>
          </div>
          
          {/* Slide Indicators */}
          <div className="flex justify-center space-x-3 mt-8">
            {Array.from({ length: totalSlides }).map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                disabled={isAnimating}
                className={`relative transition-all duration-300 ${
                  currentSlide === index 
                    ? 'w-8 h-3 bg-primary tech-glow rounded-full' 
                    : 'w-3 h-3 bg-muted-foreground/30 hover:bg-muted-foreground/50 rounded-full'
                }`}
              >
                {currentSlide === index && (
                  <div className="absolute inset-0 bg-primary rounded-full animate-pulse"></div>
                )}
              </button>
            ))}
          </div>
        </div>
        
        {/* Team Culture */}
        <Card className="p-8 bg-gradient-to-r from-accent/10 to-primary/10 border-primary/20 relative overflow-hidden">
          <FloatingParticles 
            density={8}
            size="small"
            colors={['#FFD700', '#00FFFF']}
            className="opacity-30"
          />
          
          <div className="text-center relative z-10">
            <div className="w-16 h-16 bg-gradient-to-br from-primary/20 to-accent/20 rounded-2xl flex items-center justify-center mx-auto mb-6 tech-glow">
              <Users className="w-8 h-8 text-primary" />
            </div>
            <h3 className="text-2xl font-orbitron font-bold text-primary mb-4">
              Join Our Growing Team
            </h3>
            <p className="text-muted-foreground mb-6 max-w-2xl mx-auto">
              We're always looking for talented individuals who share our passion for innovation 
              and want to make a meaningful impact in the world of technology.
            </p>
            <Button size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 tech-glow font-orbitron relative overflow-hidden group">
              <span className="relative z-10">View Open Positions</span>
              <div className="absolute inset-0 bg-gradient-to-r from-accent/20 to-secondary/20 transform translate-x-full group-hover:translate-x-0 transition-transform duration-500"></div>
            </Button>
          </div>
        </Card>
      </div>
    </section>
  );
}